/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerActivationPatchForm } from '../../models/customer-activation-patch-form';

export interface UpdateCustomerActivation$Params {

/**
 * customer id
 */
  customerId: number;
      body: CustomerActivationPatchForm
}

export function updateCustomerActivation(http: HttpClient, rootUrl: string, params: UpdateCustomerActivation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateCustomerActivation.PATH, 'patch');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateCustomerActivation.PATH = '/customers/{customerId}/activation';
